module.exports = __webpack_public_path__ + "static/media/noun_scan_3165200.6b71e7b9.svg";